import React from 'react'
import {Button, Loading} from '@therms/atalaya'
import {useEventTypes} from '@therms/react-modules'
import {getColorContrast} from '@therms/web-js'

interface PickEventTypeProps {
  onSelectEventType: (eventTypeId: string) => void
}

function PickEventType({onSelectEventType}: PickEventTypeProps) {
  const {data, loading} = useEventTypes({
    active: true,
    pagination: {limit: 500},
  })

  if (!data && loading) return <Loading overlay />

  return (
    <div className="gap-lg grid grid-cols-3">
      {data?.eventTypes
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((eventType) => (
          <Button
            key={eventType.id}
            onClick={() => onSelectEventType(eventType.id)}
            style={{
              backgroundColor: eventType.color,
              color: getColorContrast(eventType.color),
            }}
            className="py-base"
          >
            {!!eventType.name && (
              <span className="truncate">{eventType.name}</span>
            )}
          </Button>
        ))}
    </div>
  )
}

export {PickEventType}
